import React, { useState } from "react";
import FAQSubCategory from "./FAQSubCategory";

const FAQCategory = ({ category }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-4">
      <button
        onClick={() => setOpen(!open)}
        className="max-w-5xl bg-primary-green text-white text-xl md:text-3xl px-5 py-3 rounded-full w-full text-left font-bold flex items-center justify-between"
      >
        {category.title}
        <img
          src="/images/arrows/flecha1.webp"
          alt="toggle"
          className={`w-6 h-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="mt-3 space-y-2">
          {category.subcategories.map((sub, idx) => (
            <FAQSubCategory key={idx} subcategory={sub} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FAQCategory;
